import { apiCalls } from "../../api/calls/auth";
import { loginSuccess, logoutSuccess } from "../slices/authSlice";

export const loginUser = (username, password) => async (dispatch) => {
  try {
    const response = await apiCalls.Authentication.authenticateUser(username, password);
    const token = response.accessToken;
    const userRoutes = JSON.stringify(response.nsAppPages);
    const userCoordinates = JSON.stringify(response.coordinates);
    if (token && token !== "Error") {
      localStorage.setItem("AuthToken", token);
      dispatch(loginSuccess(token));
      localStorage.setItem("NsAppPages", userRoutes);
      localStorage.setItem("UserCoordinates", userCoordinates);
      return true;
    } else {
      dispatch({ type: 'LOGIN_FAILURE' });
      return false;
    }
  } catch (error) {
    dispatch({ type: 'LOGIN_FAILURE' });
    return false;
  }
};

export const ssoLogin = (ssoToken) => async (dispatch) => {
  try {
    const response = await apiCalls.Authentication.ssoLogin(ssoToken);
    const token = response.accessToken;
    const userRoutes = JSON.stringify(response.nsAppPages);
    const userCoordinates = JSON.stringify(response.coordinates);
    if (token && token !== "Error") {
      localStorage.setItem("AuthToken", token);
      dispatch(loginSuccess(token));
      localStorage.setItem("NsAppPages", userRoutes);
      localStorage.setItem("UserCoordinates", userCoordinates);
      return true;
    } else {
      dispatch({type: 'LOGIN_FAILURE'});
      return false;
    }
  } catch (error) {
    dispatch({ type: 'LOGIN_FAILURE' });
    return false;
  }
}  
  export const logoutUser = () => {
    return async (dispatch) => {
      localStorage.removeItem("AuthToken");
      localStorage.removeItem("TokenExpiration");
      localStorage.removeItem("NsAppPages");
      localStorage.removeItem("UserCoordinates");
      dispatch(logoutSuccess());
      window.location.href = '/login';
    };
  };
  
  export const checkAuth = () => {
    return async (dispatch) => {
      const token = localStorage.getItem("AuthToken");
      if (token) {
        try {
          dispatch(loginSuccess(token));
        } catch (error) {
          dispatch(logoutSuccess());
        }
      } else {
        dispatch(logoutSuccess());
      }
      dispatch({ type: 'auth/checkComplete' });
    };
  };
  